// extracted by mini-css-extract-plugin
export default {"main":"Page404_main__HC7bx","title":"Page404_title__va5RM","header":"Page404_header__rSwxu","txt":"Page404_txt__vzxAo","button":"Page404_button__Dhs0H"};